import React from 'react';
import { Link } from 'react-router-dom';
import Section from './shared/Section';
import Card from './shared/Card';
import Grid from './shared/Grid';
import * as FiIcons from 'react-icons/fi';

const { FiCode, FiTrendingUp, FiPenTool, FiSmartphone, FiShoppingCart, FiSettings } = FiIcons;

const services = [
  {
    icon: FiCode,
    title: 'Web Development',
    description: 'Custom websites and web applications built with modern technologies for optimal performance.',
    features: ['React & Next.js', 'E-commerce Solutions', 'CMS Integration', 'Performance Optimization'],
    slug: 'web-development'
  },
  {
    icon: FiTrendingUp,
    title: 'Digital Marketing',
    description: 'Data-driven marketing strategies that increase your online presence and drive conversions.',
    features: ['SEO Optimization', 'PPC Campaigns', 'Social Media', 'Analytics & Reporting'],
    slug: 'digital-marketing'
  },
  {
    icon: FiPenTool,
    title: 'Brand Design',
    description: 'Creative branding solutions that capture your unique identity and resonate with your audience.',
    features: ['Logo Design', 'Brand Guidelines', 'Marketing Materials', 'UI/UX Design'],
    slug: 'brand-design'
  },
  {
    icon: FiSmartphone,
    title: 'Mobile Solutions',
    description: 'Native and cross-platform mobile applications that deliver exceptional user experiences.',
    features: ['iOS & Android', 'React Native', 'Progressive Web Apps', 'App Store Optimization'],
    slug: 'mobile-solutions'
  },
  {
    icon: FiShoppingCart,
    title: 'E-commerce',
    description: 'Complete e-commerce solutions from design to payment processing and inventory management.',
    features: ['Shopify Development', 'WooCommerce', 'Payment Integration', 'Inventory Systems'],
    slug: 'e-commerce'
  },
  {
    icon: FiSettings,
    title: 'Consulting',
    description: 'Strategic technology consulting to help you make informed decisions about your digital future.',
    features: ['Technology Audit', 'Digital Strategy', 'Process Optimization', 'Team Training'],
    slug: 'consulting'
  }
];

const Services = () => {
  return (
    <Section
      id="services"
      title="What we do"
      subtitle="We offer comprehensive digital solutions to help your business thrive in the modern marketplace."
    >
      <Grid cols={{ default: 1, md: 2, lg: 3 }}>
        {services.map((service, index) => (
          <Card
            key={index}
            title={service.title}
            description={service.description}
            icon={service.icon}
            tags={service.features}
            link={{
              to: `/services/${service.slug}`,
              text: "Learn More"
            }}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
          />
        ))}
      </Grid>
    </Section>
  );
};

export default Services;